import React from "react";
import Button from "@mui/material/Button";
import "./plans.scss";
import { connect } from "react-redux";
import { useAuth } from "../../../contexts/Auth";
import { CircularProgress } from "@material-ui/core";

const AdvancedPlan = ({ userSettings, openModal, hasSubmitted }) => {
  const { hasOptionsMentorshipAdvanced, loading } = useAuth();
  const processing =
    !!userSettings?.om_advanced_sign_up ||
    !!userSettings?.om_advanced_renewed ||
    hasOptionsMentorshipAdvanced ||
    hasSubmitted;
  return (
    <div className="subscribe-plan-item advanced-item">
      <div className="subscribe-plan-item-title">
        TradeAlgo Options
        <br />
        Mentorship: <span className="subscribe-plan-item-type">Advanced</span>
      </div>
      <div className="subscribe-plan-item-includes-title">Includes</div>
      <ul className="subscribe-plan-item-includes-entries">
        <li className="subscribe-plan-item-includes-entry">
          29 sessions over 12 months
        </li>
        <li className="subscribe-plan-item-includes-entry">
          Options trading pro-led personalized coaching
        </li>
      </ul>
      <div className="subscribe-plan-item-price">
        <span className="subscribe-plan-item-small-text">USD</span> $7,000
      </div>
      <Button
        sx={{ width: processing ? "215px !important" : "" }}
        disabled={processing || loading}
        className="subscribe-plan-item-button"
        onClick={() => openModal("OPTIONS MENTORSHIP ADVANCED")}
      >
        {loading ? (
          <CircularProgress color="success" size={24} />
        ) : processing ? (
          "Access Requested"
        ) : (
          "Contact Us"
        )}
      </Button>
    </div>
  );
};

const stateToProps = (state) => ({
  userSettings: state.userSettings.userSettings,
});

export default connect(stateToProps, null)(AdvancedPlan);
